const SplitTextAnimation = new function () {
	this.init = () => {
		document.querySelectorAll('.sn-section--2').forEach(section => {
			const textElement = section.querySelector('.sn-quotation__text')
			if (!textElement) return

			const split = new SplitType(textElement, {
				types: 'lines',
			})

			split.lines.forEach(line => {
				line.style.display = 'block'
				gsap.set(line, { opacity: 0.2 })

				gsap.to(line, {
					opacity: 1,
					scrollTrigger: {
						trigger: line,
						start: 'top center',
						end: 'top center',
						scrub: true,
						scroller: document.querySelector('#sn-page') || document.body,
					},
				})
			})
		})
	}
}

export default SplitTextAnimation